module.exports = __webpack_public_path__ + "img/ug336.964ddccb.png";